import {
  FETCH_ROOM_DEPOSIT_WAITING_REQUEST,
  FETCH_ROOM_DEPOSIT_WAITING_SUCCESS,
  FETCH_ROOM_DEPOSIT_WAITING_FAILURE,
  FETCH_ROOM_DEPOSIT_SUBTOTAL_REQUEST,
  FETCH_ROOM_DEPOSIT_SUBTOTAL_SUCCESS,
  FETCH_ROOM_DEPOSIT_SUBTOTAL_FAILURE,
  UPDATE_ROOM_DEPOSIT_REQUEST,
  UPDATE_ROOM_DEPOSIT_SUCCESS,
  UPDATE_ROOM_DEPOSIT_FAILURE,
} from "../action/roomDepositActions";

const initialState = {
  waitingDeposits: [], // Stores waiting deposits data
  loading: false,
  error: null,
};

const roomDepositReducer = (state = initialState, action) => {
  switch (action.type) {
    // Handling waiting deposits fetch
    case FETCH_ROOM_DEPOSIT_WAITING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        waitingDeposits: [], // Reset waiting deposits while fetching
      };
    case FETCH_ROOM_DEPOSIT_WAITING_SUCCESS:
      return {
        ...state,
        loading: false,
        waitingDeposits: action.payload, // Populate waiting deposits
        error: null,
      };
    case FETCH_ROOM_DEPOSIT_WAITING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to fetch waiting deposits",
      };

    // Handling subtotal fetch for waiting deposits
    case FETCH_ROOM_DEPOSIT_SUBTOTAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ROOM_DEPOSIT_SUBTOTAL_SUCCESS:
      return {
        ...state,
        loading: false,
        waitingDeposits: action.payload, // Update subtotal value
        error: null,
      };
    case FETCH_ROOM_DEPOSIT_SUBTOTAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to fetch subtotal",
      };

    // Handling room deposit update
    case UPDATE_ROOM_DEPOSIT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_ROOM_DEPOSIT_SUCCESS:
      // Extract the updated deposit and the id from the action payload
      const { data } = action.payload;

      return {
        ...state,
        loading: false,
        // Update the waitingDeposits array with the updated deposit
        waitingDeposits: state.waitingDeposits.map((deposit) =>
          deposit.id === data.id ? { ...deposit, ...data } : deposit
        ),
        error: null,
      };
    case UPDATE_ROOM_DEPOSIT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to update deposit",
      };

    default:
      return state;
  }
};

export default roomDepositReducer;
